import { useMemo } from "react";
import type { Retreat } from "shared/types";

type UseCorralFormOptionsProps = {
  retreats: Retreat[];
};

export function useCorralFormOptions({ retreats }: UseCorralFormOptionsProps) {
  const retreatOptions = useMemo(
    () =>
      retreats
        .map((item) => ({
          value: item.id,
          label: item.name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [retreats]
  );

  return { retreatOptions };
}
